// import { useEffect, useState } from 'react';
// import '../../styles/login.scss';
// import logo from '../../assets/images/GOVT_LOGO.png';
// import illustration from '../../assets/images/login3_cover.jpg';
// import { useNavigate } from 'react-router-dom';
// import { useUI } from '../../shared/UI/Uicontext';
// import { alertService } from '../../shared/services/alertService';

// import {
//   useRequestOtpMutation,
//   useSubmitOtpMutation,
//   useUpdatePasswordMutation,
//   useLoginMutation,
//   useLazyGetTnEmisMenuOptionsQuery,
// } from './Login.service';
// import { decryptData } from '../../shared/services/cryptoService';
// import { getSessionData } from 'utils.session';
// import { toast } from 'react-toastify';

// // ================= LOGIN ATTEMPT TRACKING =================
// const MAX_ATTEMPTS = 5;
// const LOCKOUT_DURATION_MS = 30 * 60 * 1000; // 30 minutes

// const getAttemptData = () => {
//   const raw = localStorage.getItem('loginAttempts');
//   if (!raw) return { count: 0, lockedUntil: null };
//   try {
//     return JSON.parse(raw);
//   } catch {
//     return { count: 0, lockedUntil: null };
//   }
// };

// const setAttemptData = (data: {
//   count: number;
//   lockedUntil: number | null;
// }) => {
//   localStorage.setItem('loginAttempts', JSON.stringify(data));
// };

// const isCurrentlyLocked = () => {
//   const { lockedUntil } = getAttemptData();
//   if (lockedUntil && Date.now() < lockedUntil) {
//     return true;
//   }
//   // lock expired — reset
//   if (lockedUntil && Date.now() >= lockedUntil) {
//     setAttemptData({ count: 0, lockedUntil: null });
//   }
//   return false;
// };

// const getRemainingLockTime = () => {
//   const { lockedUntil } = getAttemptData();
//   if (!lockedUntil) return '';

//   const diffMs = lockedUntil - Date.now();
//   const totalMinutes = Math.ceil(diffMs / (60 * 1000));

//   if (totalMinutes >= 60) {
//     return '1 hour';
//   }
//   if (totalMinutes <= 1) {
//     return 'a minute';
//   }
//   return `${totalMinutes} minutes`;
// };

// export default function Login() {
//   const navigate = useNavigate();
//   // In Login.tsx — update useEffect
//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       navigate('/dashboard', { replace: true });
//     }
//     // ← No else, just let login page render if no token
//   }, []); // ← runs once on mount
//   const { showLoader, hideLoader } = useUI();
//   const [requestOtpApi] = useRequestOtpMutation();
//   const [submitOtpApi] = useSubmitOtpMutation();
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [updatePasswordApi] = useUpdatePasswordMutation();
//   // ================= LOGIN =================
//   const [passShow, setPassShow] = useState(true);
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [usernameTouched, setUsernameTouched] = useState(false);
//   const [passwordTouched, setPasswordTouched] = useState(false);
//   const [submitted, setSubmitted] = useState(false);

//   // ================= FORGOT PASSWORD =================
//   const [showLoginPage, setShowLoginPage] = useState(true);
//   const [showForgotPasswordPage, setShowForgotPasswordPage] = useState(false);

//   const [forgotUsername, setForgotUsername] = useState('');
//   const [forgotTouched, setForgotTouched] = useState(false);
//   const [forgetSubmitted, setForgetSubmitted] = useState(false);

//   // ================= OTP =================
//   //const [showSuccessOtp, setShowSuccessOtp] = useState(false);
//   const [otpConfirmation, setOtpConfirmation] = useState(false);

//   const [otpValue, setOtpValue] = useState('');
//   const [showPass, setShowPass] = useState(false);

//   const [newPassValue, setNewPassValue] = useState('');
//   const [validation, setValidation] = useState(true);

//   const usernameError = !username && (submitted || usernameTouched);

//   const passwordError = !password && (submitted || passwordTouched);

//   const forgotError = !forgotUsername && (forgetSubmitted || forgotTouched);
//   const [isLocked, setIsLocked] = useState(() => isCurrentlyLocked());
//   // ================= LOGIN =================
//   const [loginApi] = useLoginMutation();
//   const [getTnEmisMenuOptions] = useLazyGetTnEmisMenuOptionsQuery();

//   const handleLogin = async () => {
//     setSubmitted(true);
//     if (!username || !password) return;

//     if (isCurrentlyLocked()) {
//       setIsLocked(true);
//       const timeLeft = getRemainingLockTime();
//       alertService.error(
//         `Your account is temporarily locked due to multiple incorrect login attempts. Please try again in ${timeLeft}.`
//       );
//       return;
//     }

//     try {
//       showLoader();

//       const loginResponse = await loginApi({ username, password }).unwrap();

//       let decryptedResponse;
//       try {
//         decryptedResponse = decryptData(loginResponse);
//       } catch {
//         decryptedResponse = loginResponse;
//       }

//       if (!decryptedResponse?.dataStatus) {
//         hideLoader();

//         // ── Track failed attempt ──
//         const { count } = getAttemptData();
//         const newCount = count + 1;

//         if (newCount >= MAX_ATTEMPTS) {
//           setAttemptData({
//             count: newCount,
//             lockedUntil: Date.now() + LOCKOUT_DURATION_MS,
//           });
//           alertService.error(
//             'Too many incorrect login attempts. Your account has been temporarily locked for 30 minutes. Please try again later.'
//           );
//         } else {
//           setAttemptData({ count: newCount, lockedUntil: null });
//           alertService.error(
//             decryptedResponse?.message || 'Invalid username or password'
//           );
//         }
//         return;
//       }

//       // ── Login succeeded — reset attempt tracking ──
//       setAttemptData({ count: 0, lockedUntil: null });

//       const token = decryptedResponse?.records?.token;
//       if (!token) {
//         alertService.error('Token not found');
//         return;
//       }

//       localStorage.setItem('token', token);

//       const sessionData = getSessionData();
//       // console.log('Decoded Session Data:', sessionData);
//       // console.log('mod2:', sessionData?.mod2);
//       // console.log('usertypeid:', sessionData?.usertypeid);

//       const blockedUserTypes = [1, 8, 11, 22, 28];
//       const isBlockedTeacher =
//         sessionData?.usertypeid === 14 && sessionData?.teacherType !== 103;

//       if (
//         blockedUserTypes.includes(sessionData?.usertypeid) ||
//         isBlockedTeacher
//       ) {
//         alertService.info('Please Login from "emis.tnschools.gov.in"');
//         localStorage.clear();
//         return;
//       }

//       // ── Step 1: Validate modList from JWT FIRST ──
//       const modList = sessionData?.mod2 || '';
//       if (!modList) {
//         alertService.info(
//           'We are upgrading our portal for an enhanced experience. Kindly check for updates later. Thank you for understanding!'
//         );
//         localStorage.clear();
//         hideLoader();
//         return;
//       }

//       // ── Step 2: Fetch menus ──
//       const menuResponse = await getTnEmisMenuOptions().unwrap();

//       if (menuResponse?.status === 200) {
//         const angularMenus = menuResponse.result.tnemis || [];
//         const reactMenus = menuResponse.result['tnemis-react'] || [];
//         const allMenus = [...angularMenus, ...reactMenus];

//         localStorage.setItem('MenuList', JSON.stringify(allMenus));
//         localStorage.setItem('ReactMenus', JSON.stringify(reactMenus));

//         // console.log('tnemis menus:', menuResponse.result['tnemis']);

//         // ── Step 3: Collect ALL tnemis-react IDs (full tree walk) ──
//         const collectAllIds = (nodes: any[]): string[] => {
//           if (!nodes) return [];
//           const ids: string[] = [];
//           nodes.forEach((node) => {
//             if (node?.id != null) ids.push(String(node.id));
//             if (node?.subMenus) {
//               node.subMenus.forEach((group: any) => {
//                 ids.push(...collectAllIds(group?.subMenuItems || []));
//               });
//             }
//           });
//           return ids;
//         };

//         const reactIds = collectAllIds(reactMenus);

//         // ── Step 4: Merge modList + reactIds, then save ONCE ──
//         const mergedModList =
//           reactIds.length > 0 ? modList + ',' + reactIds.join(',') : modList;

//         localStorage.setItem('ModList', JSON.stringify(mergedModList));
//         // console.log('ModList saved:', mergedModList);
//       } else {
//         // Menu fetch failed — still save base modList
//         localStorage.setItem('ModList', JSON.stringify(modList));
//         // console.log('ModList saved (no menu):', modList);
//       }

//       // console.log('MenuList saved');

//       hideLoader();
//       alertService.success('Login Successful');

//       localStorage.setItem('token', token);
//       localStorage.setItem('username', username);

//       navigate('/dashboard');
//     } catch (error: any) {
//       hideLoader();
//       const message =
//         error?.data?.message ||
//         error?.data?.error ||
//         error?.message ||
//         'Login Failed';
//       toast.dismiss();
//       alertService.error(message);
//     }
//   };
//   // const getAuthorizationKey = async () => {
//   //   try {
//   //     const response = await fetch(
//   //       'https://fcabjcr87c.execute-api.ap-south-1.amazonaws.com/api/authkey'
//   //     );

//   //     const result = await response.json();

//   //     const parsedJson = JSON.parse(result.body);

//   //     localStorage.setItem('AuthorizationKey', parsedJson.Authorization_key);

//   //     return true;
//   //   } catch (error) {
//   //     console.error(error);
//   //     return false;
//   //   }
//   // };
//   // ================= SHOW FORGOT PASSWORD =================
//   const handleForgotPassword = () => {
//     setShowLoginPage(false);
//     setShowForgotPasswordPage(true);
//   };

//   // ================= BACK TO LOGIN =================
//   const handleBackToLogin = () => {
//     setShowForgotPasswordPage(false);
//     setShowLoginPage(true);

//     setForgotUsername('');
//     setOtpValue('');
//     setNewPassValue('');
//     setShowPass(false);
//   };

//   const requestOtp = async () => {
//     setForgetSubmitted(true);

//     if (!forgotUsername.trim()) {
//       alertService.warning('Please enter the User Id');
//       return;
//     }

//     try {
//       showLoader();

//       const payload = {
//         UserId: forgotUsername,
//         newPassword: confirmPassword,
//       };

//       const apiResponse = await requestOtpApi(payload).unwrap();

//       const decryptedResponse: any = decryptData(apiResponse);

//       hideLoader();

//       if (decryptedResponse?.dataStatus) {
//         setShowPass(false);
//         setOtpValue('');
//         setNewPassValue('');
//         setValidation(true);

//         setOtpConfirmation(true);

//         alertService.success(
//           decryptedResponse?.message || 'OTP Sent Successfully'
//         );
//       } else {
//         alertService.error(decryptedResponse?.message || 'Failed to send OTP'); // ← THIS LINE
//       }
//     } catch (error: any) {
//       hideLoader();

//       alertService.error(error?.data?.message || 'Something went wrong');
//     }
//   };
//   // ================= OPEN OTP POPUP =================
//   const showOtpSubmit = () => {
//     setForgetSubmitted(true);

//     if (!forgotUsername.trim()) {
//       alertService.error('Please Enter User ID');
//       return;
//     }

//     setShowPass(false);
//     setOtpValue('');
//     setNewPassValue('');
//     setValidation(true);

//     setOtpConfirmation(true);
//   };

//   // ================= SUBMIT OTP =================
//   const submitOtp = async () => {
//     if (!otpValue) {
//       alertService.error('Please Enter the OTP');
//       return;
//     }

//     try {
//       showLoader();

//       const response = await submitOtpApi({
//         username: forgotUsername,
//         otp: otpValue,
//       }).unwrap();

//       const decryptedResponse: any = decryptData(response);

//       hideLoader();

//       if (decryptedResponse?.dataStatus) {
//         alertService.success(decryptedResponse?.message);

//         // OPEN PASSWORD FIELD ONLY AFTER SUCCESS
//         setShowPass(true);
//       } else {
//         alertService.error(decryptedResponse?.message);
//       }
//     } catch (error: any) {
//       hideLoader();

//       alertService.error(error?.data?.message || 'Something went wrong');
//     }
//   };

//   // ================= PASSWORD VALIDATION =================
//   const checkPasswordValid = (value: string) => {
//     setNewPassValue(value);

//     const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,15}$/;

//     setValidation(regex.test(value));
//   };

//   const closeOtpPopup = () => {
//     setOtpConfirmation(false);
//     setShowPass(false);
//     setOtpValue('');
//     setNewPassValue('');
//     setValidation(true);
//   };

//   // ================= SUBMIT PASSWORD =================
//   const submitPassword = async () => {
//     if (!validation || !newPassValue) {
//       alertService.error('Please enter the valid password');
//       return;
//     }

//     try {
//       showLoader();

//       const response = await updatePasswordApi({
//         username: forgotUsername,
//         newPass: newPassValue,
//       }).unwrap();

//       const decryptedResponse: any = decryptData(response);

//       hideLoader();

//       if (decryptedResponse?.dataStatus) {
//         alertService.success(
//           decryptedResponse?.message || 'Password Changed Successfully'
//         );

//         setOtpConfirmation(false);

//         handleBackToLogin();
//       } else {
//         alertService.error(decryptedResponse?.message);
//       }
//     } catch (error: any) {
//       hideLoader();

//       alertService.error(error?.data?.message || 'Something went wrong');
//     }
//   };

//   // ================= LOGIN ATTEMPT TRACKING =================
//   const MAX_ATTEMPTS = 5;
//   const LOCKOUT_DURATION_MS = 60 * 60 * 1000;

//   const getAttemptData = () => {
//     const raw = localStorage.getItem('loginAttempts');
//     if (!raw) return { count: 0, lockedUntil: null };
//     try {
//       return JSON.parse(raw);
//     } catch {
//       return { count: 0, lockedUntil: null };
//     }
//   };

//   const setAttemptData = (data: {
//     count: number;
//     lockedUntil: number | null;
//   }) => {
//     localStorage.setItem('loginAttempts', JSON.stringify(data));
//   };

//   const isCurrentlyLocked = () => {
//     const { lockedUntil } = getAttemptData();
//     if (lockedUntil && Date.now() < lockedUntil) {
//       return true;
//     }
//     // lock expired — reset
//     if (lockedUntil && Date.now() >= lockedUntil) {
//       setAttemptData({ count: 0, lockedUntil: null });
//     }
//     return false;
//   };

//   const getRemainingLockTime = () => {
//     const { lockedUntil } = getAttemptData();
//     if (!lockedUntil) return '';

//     const diffMs = lockedUntil - Date.now();
//     const totalMinutes = Math.ceil(diffMs / (60 * 1000));

//     if (totalMinutes <= 1) {
//       return 'a minute';
//     }
//     return `${totalMinutes} minutes`;
//   };
//   return (
//     <div className="row w-100 mx-0 auth-page">
//       <div className="col-md-8 col-xl-6 mx-auto">
//         <div className="card">
//           <div className="row g-0">
//             <div className="col-md-4 pe-md-0 imagelogo">
//               <div
//                 className="auth-side-wrapper"
//                 style={{
//                   backgroundImage: `url(${illustration})`,
//                 }}
//               />
//             </div>

//             <div className="col-md-8 ps-md-0">
//               <div
//                 className="auth-form-wrapper px-4 py-5"
//                 style={{
//                   fontFamily: 'Arial, sans-serif',
//                   fontSize: '14px',
//                   lineHeight: '1.5',
//                 }}
//               >
//                 <img src={logo} className="image" alt="Government Logo" />

//                 <h5 className="headingcenter1 text-muted fw-normal mb-4 text-center">
//                   கல்வி மேலாண்மைத் தகவல் மையம்
//                 </h5>

//                 {/* ================= LOGIN PAGE ================= */}

//                 {showLoginPage && (
//                   <>
//                     <div className="mb-3">
//                       <label htmlFor="loginUsername" className="form-label">
//                         User Name
//                       </label>

//                       <input
//                         type="text"
//                         className="form-control"
//                         id="loginUsername"
//                         placeholder="User Name"
//                         value={username}
//                         maxLength={8}
//                         onChange={(e) => {
//                           const numericValue = e.target.value.replace(
//                             /[^0-9]/g,
//                             ''
//                           );
//                           setUsername(numericValue);
//                         }}
//                         onBlur={() => setUsernameTouched(true)}
//                         inputMode="numeric"
//                         pattern="[0-9]*"
//                       />

//                       {usernameError && (
//                         <small className="form-text text-danger">
//                           Enter User Name
//                         </small>
//                       )}
//                     </div>

//                     <div className="mb-3">
//                       <label htmlFor="loginPassword" className="form-label">
//                         Password
//                       </label>

//                       <div className="position-relative w-100">
//                         <input
//                           type={passShow ? 'password' : 'text'}
//                           className="form-control pe-5"
//                           id="loginPassword"
//                           placeholder="Password"
//                           value={password}
//                           onChange={(e) => setPassword(e.target.value)}
//                           onBlur={() => setPasswordTouched(true)}
//                         />

//                         <i
//                           className={`${passShow ? 'pi pi-eye' : 'pi pi-eye-slash'} position-absolute top-50 end-0 translate-middle-y me-3`}
//                           style={{ cursor: 'pointer' }}
//                           onClick={() => setPassShow(!passShow)}
//                         />
//                       </div>

//                       {passwordError && (
//                         <small className="text-danger">Enter Password</small>
//                       )}
//                     </div>

//                     <div className="row mt-2">
//                       <div className="col-12 text-center">
//                         <button
//                           type="button"
//                           className="btn btn-primary me-2 mb-2 mb-md-0"
//                           onClick={handleLogin}
//                         >
//                           Login
//                         </button>

//                         <button
//                           type="button"
//                           className="btn btn-primary me-2 mb-2 mb-md-0"
//                           onClick={handleForgotPassword}
//                         >
//                           Forgot Password
//                         </button>
//                       </div>
//                     </div>
//                   </>
//                 )}

//                 {/* ================= FORGOT PASSWORD PAGE ================= */}

//                 {showForgotPasswordPage && (
//                   <>
//                     <br />

//                     <div className="mb-2">
//                       <label className="form-label">
//                         Enter User Id
//                         <span className="text-danger"> *</span>
//                       </label>

//                       <input
//                         type="text"
//                         className="form-control forgot-input"
//                         placeholder="Enter User Id"
//                         value={forgotUsername}
//                         onChange={(e) => {
//                           const numericValue = e.target.value.replace(
//                             /[^0-9]/g,
//                             ''
//                           );
//                           setForgotUsername(numericValue);
//                         }}
//                         onBlur={() => setForgotTouched(true)}
//                         inputMode="numeric"
//                         pattern="[0-9]*"
//                       />

//                       {forgotError && (
//                         <small className="form-text text-danger">
//                           Enter User Id
//                         </small>
//                       )}
//                     </div>

//                     <br />

//                     <div className="row">
//                       <div className="col text-center">
//                         <button
//                           type="button"
//                           className="btn btn-primary me-2 mb-2 mb-md-0"
//                           onClick={requestOtp}
//                         >
//                           Request OTP
//                         </button>

//                         <button
//                           type="button"
//                           className="btn btn-primary me-2 mb-2 mb-md-0"
//                           onClick={showOtpSubmit}
//                         >
//                           Submit OTP
//                         </button>

//                         <button
//                           type="button"
//                           className="btn btn-primary me-2 mb-2 mb-md-0"
//                           onClick={handleBackToLogin}
//                         >
//                           Back To Login
//                         </button>
//                       </div>
//                     </div>
//                   </>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ================= OTP SUCCESS POPUP ================= */}

//       {/* {showSuccessOtp && (
//         <div className="custom-modal">
//           <div className="custom-modal-content text-center">
//             <h5>OTP Sent Successfully</h5>

//             <p className="mt-3">OTP sent to your registered mail/mobile</p>

//             <button
//               className="btn btn-warning mt-2"
//               onClick={() => setShowSuccessOtp(false)}
//             >
//               Ok
//             </button>
//           </div>
//         </div>
//       )} */}

//       {otpConfirmation && !showPass && (
//         <div className="otp-modal">
//           <div className="otp-modal-content">
//             <div className="otp-modal-header">OTP Submission</div>

//             <div className="otp-modal-body">
//               <div className="otp-row">
//                 <div className="otp-input-section">
//                   <label className="form-label">
//                     OTP <span className="text-danger">*</span>
//                   </label>

//                   <input
//                     type="text"
//                     className="form-control otp-input"
//                     placeholder="Enter the OTP"
//                     maxLength={6}
//                     value={otpValue}
//                     onChange={(e) => setOtpValue(e.target.value)}
//                   />
//                 </div>

//                 <div className="otp-button-section">
//                   <button className="btn-submit-otp" onClick={submitOtp}>
//                     Submit OTP
//                   </button>
//                 </div>
//               </div>

//               <div className="otp-footer">
//                 <button className="btn-close-otp" onClick={closeOtpPopup}>
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {/* ================= OTP SUBMISSION POPUP ================= */}

//       {otpConfirmation && !showPass && (
//         <div className="otp-modal">
//           <div className="otp-modal-content">
//             <div className="otp-modal-header">OTP Submission</div>

//             <div className="otp-modal-body">
//               <div className="otp-input-section">
//                 <label className="form-label">
//                   OTP <span className="text-danger">*</span>
//                 </label>

//                 <input
//                   type="text"
//                   className="form-control otp-input"
//                   placeholder="Enter the OTP"
//                   maxLength={6}
//                   value={otpValue}
//                   onChange={(e) => setOtpValue(e.target.value)}
//                 />
//               </div>

//               <div className="otp-footer">
//                 <button className="btn-submit-otp" onClick={submitOtp}>
//                   Submit OTP
//                 </button>
//                 <button className="btn-close-otp" onClick={closeOtpPopup}>
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

import { useEffect, useState } from 'react';
import '../../styles/login.scss';
import logo from '../../assets/images/GOVT_LOGO.png';
import illustration from '../../assets/images/login3_cover.jpg';
import { useNavigate } from 'react-router-dom';
import { useUI } from '../../shared/UI/Uicontext';
import { alertService } from '../../shared/services/alertService';

import {
  useRequestOtpMutation,
  useSubmitOtpMutation,
  useUpdatePasswordMutation,
  useLoginMutation,
  useLazyGetCurrentAyQuery,
} from './Login.service';
import { decryptData } from '../../shared/services/cryptoService';
import { getSessionData } from 'utils.session';
import { toast } from 'react-toastify';
import { primeAngularSession } from '../../shared/services/sessionBridge';
import CryptoJS from 'crypto-js';
import { ENV_CONFIG } from '../../shared/config/env.config';

export default function Login() {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useUI();

  // ================= LOCKOUT HELPERS =================
  const MAX_ATTEMPTS = 5;
  const LOCKOUT_DURATION_MS = 30 * 60 * 1000; // 30 minutes

  const getAttemptData = () => {
    const raw = localStorage.getItem('loginAttempts');
    if (!raw) return { count: 0, lockedUntil: null };
    try {
      return JSON.parse(raw);
    } catch {
      return { count: 0, lockedUntil: null };
    }
  };

  const setAttemptData = (data: {
    count: number;
    lockedUntil: number | null;
  }) => {
    localStorage.setItem('loginAttempts', JSON.stringify(data));
  };

  const isCurrentlyLocked = () => {
    const { lockedUntil } = getAttemptData();
    // eslint-disable-next-line react-hooks/purity
    if (lockedUntil && Date.now() < lockedUntil) {
      return true;
    }
    // lock expired — reset
    // eslint-disable-next-line react-hooks/purity
    if (lockedUntil && Date.now() >= lockedUntil) {
      setAttemptData({ count: 0, lockedUntil: null });
    }
    return false;
  };

  const getRemainingLockTime = () => {
    const { lockedUntil } = getAttemptData();
    if (!lockedUntil) return '';

    // eslint-disable-next-line react-hooks/purity
    const diffMs = lockedUntil - Date.now();
    const totalMinutes = Math.ceil(diffMs / (60 * 1000));

    if (totalMinutes <= 1) {
      return 'a minute';
    }
    return `${totalMinutes} minutes`;
  };

  const [isLocked, setIsLocked] = useState(() => isCurrentlyLocked());

  // In Login.tsx — update useEffect
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const session = getSessionData();
      const uType = Number(session?.usertypeid) || 0;
      const uType1 = Number(session?.emisUsertype1) || 0;
      const storedUsername = localStorage.getItem('username');
      // HR users (usertype=21, usertype1=17) or admin user go to mail-request
      if ((uType === 21 && uType1 === 23) || storedUsername === '4028619') {
        navigate('/mail-request', { replace: true });
      } else {
        navigate('/dashboard', { replace: true });
      }
    }
  }, []);

  useEffect(() => {
    if (!isLocked) return;
    const interval = setInterval(() => {
      if (!isCurrentlyLocked()) {
        setIsLocked(false);
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [isLocked]);
  const [requestOtpApi] = useRequestOtpMutation();
  const [submitOtpApi] = useSubmitOtpMutation();
  const [confirmPassword, setConfirmPassword] = useState('');
  const [updatePasswordApi] = useUpdatePasswordMutation();
  // ================= LOGIN =================
  const [passShow, setPassShow] = useState(true);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [usernameTouched, setUsernameTouched] = useState(false);
  const [passwordTouched, setPasswordTouched] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  // ================= FORGOT PASSWORD =================
  const [showLoginPage, setShowLoginPage] = useState(true);
  const [showForgotPasswordPage, setShowForgotPasswordPage] = useState(false);

  const [forgotUsername, setForgotUsername] = useState('');
  const [forgotTouched, setForgotTouched] = useState(false);
  const [forgetSubmitted, setForgetSubmitted] = useState(false);

  // ================= OTP =================
  //const [showSuccessOtp, setShowSuccessOtp] = useState(false);
  const [otpConfirmation, setOtpConfirmation] = useState(false);

  const [otpValue, setOtpValue] = useState('');
  const [showPass, setShowPass] = useState(false);

  const [newPassValue, setNewPassValue] = useState('');
  const [validation, setValidation] = useState(true);

  const usernameError = !username && (submitted || usernameTouched);

  const passwordError = !password && (submitted || passwordTouched);

  const forgotError = !forgotUsername && (forgetSubmitted || forgotTouched);
  // ================= LOGIN =================
  const [loginApi] = useLoginMutation();
  const [getCurrentAy] = useLazyGetCurrentAyQuery();

  const handleLogin = async () => {
    console.log(ENV_CONFIG, 'ENV_CONFIG');

    setSubmitted(true);
    if (!username || !password) return;

    if (isCurrentlyLocked()) {
      setIsLocked(true);
      const timeLeft = getRemainingLockTime();
      alertService.error(
        `Your account is temporarily locked due to multiple incorrect login attempts. Please try again in ${timeLeft}.`
      );
      return;
    }

    try {
      showLoader();

      const loginResponse = await loginApi({ username, password }).unwrap();

      let decryptedResponse;
      try {
        decryptedResponse = decryptData(loginResponse);
      } catch {
        decryptedResponse = loginResponse;
      }

      if (!decryptedResponse?.dataStatus) {
        hideLoader();

        // ── Track failed attempt ──
        const { count } = getAttemptData();
        const newCount = count + 1;

        if (newCount >= MAX_ATTEMPTS) {
          setAttemptData({
            count: newCount,
            // eslint-disable-next-line react-hooks/purity
            lockedUntil: Date.now() + LOCKOUT_DURATION_MS,
          });
          alertService.error(
            'Too many incorrect login attempts. Your account has been temporarily locked for 30 minutes. Please try again later.'
          );
        } else {
          setAttemptData({ count: newCount, lockedUntil: null });
          alertService.error(
            decryptedResponse?.message || 'Invalid username or password'
          );
        }
        return;
      }

      // ── Login succeeded — reset attempt tracking ──
      setAttemptData({ count: 0, lockedUntil: null });

      const token = decryptedResponse?.records?.token;
      if (!token) {
        alertService.error('Token not found');
        return;
      }

      localStorage.setItem('token', token);

      const sessionData = getSessionData();
      console.log('Decoded Session Data:', sessionData);
      console.log('mod2:', sessionData?.mod2);
      console.log('usertypeid:', sessionData?.usertypeid);
      console.log('usertypeid:', sessionData?.emisUsertype1);

      const blockedUserTypes = [1, 8, 11, 22, 28];
      const isBlockedTeacher =
        sessionData?.usertypeid === 14 && sessionData?.teacherType !== 103;

      if (
        blockedUserTypes.includes(sessionData?.usertypeid) ||
        isBlockedTeacher
      ) {
        alertService.info('Please Login from "emis.tnschools.gov.in"');
        localStorage.clear();
        return;
      }

      // ── Step 1: Validate modList from JWT FIRST ──
      const rawModList = sessionData?.mod2 || '';
      const emisUserTypeCheck = Number(sessionData?.usertypeid) || 0;
      const emisUserType1Check = Number(sessionData?.emisUsertype1) || 0;
      // Allow HR users (usertype=21, usertype1=23) to bypass mod2 check
      const isModListExempt =
        emisUserTypeCheck === 21 && emisUserType1Check === 23;
      if (!rawModList && !isModListExempt) {
        alertService.info(
          'We are upgrading our portal for an enhanced experience. Kindly check for updates later. Thank you for understanding!'
        );
        localStorage.clear();
        hideLoader();
        return;
      }

      // ── Step 2: Fetch menus from static JSON (same as Angular) ──
      const menuJsonUrl = process.env.REACT_APP_API_menuJson || '';
      let menuDetails: {
        tnemis: any[];
        'tnemis-react': any[];
        'tnemis-react-children': any[];
        other: any[];
      } = {
        tnemis: [],
        'tnemis-react': [],
        'tnemis-react-children': [],
        other: [],
      };

      try {
        const rawMenu: any[] = await fetch(menuJsonUrl).then((r) => r.json());
        const allItems = rawMenu || [];

        // Recursive helper: removes only inactive children (is_active != 1)
        // React children STAY in their parent's dropdown — they redirect on click
        const filterInactive = (item: any): any => {
          if (!item.subMenus || !Array.isArray(item.subMenus)) return item;
          const filteredSubMenus = item.subMenus
            .map((group: any) => {
              if (!group.subMenuItems) return group;
              const filtered = group.subMenuItems.filter(
                (sub: any) => sub.is_active == 1
              );
              return { subMenuItems: filtered };
            })
            .filter((group: any) => group.subMenuItems.length > 0);
          return { ...item, subMenus: filteredSubMenus };
        };

        // Top-level React items + remove inactive children
        const reactItems = allItems
          .filter(
            (m: any) =>
              m.is_active == 1 &&
              m.website &&
              String(m.website).toLowerCase() === 'tnemis-react'
          )
          .map((m: any) => filterInactive(m));

        // Top-level Angular items + remove inactive children
        // React children stay in for redirect detection on the Angular side
        const angularItems = allItems
          .filter(
            (m: any) =>
              m.is_active == 1 &&
              (!m.website || String(m.website).toLowerCase() !== 'tnemis-react')
          )
          .map((m: any) => filterInactive(m))
          .filter(
            (m: any) => !m.subMenus || m.subMenus.length > 0 || !m.isMegaMenu
          );

        // Collect React subMenuItems buried inside Angular parent menus
        // Tagged with _parentId and _parentLabel for navbar grouping
        const reactFromMixed: any[] = [];
        allItems
          .filter(
            (m: any) =>
              m.is_active == 1 &&
              (!m.website || String(m.website).toLowerCase() !== 'tnemis-react')
          )
          .forEach((item: any) => {
            if (!item.subMenus) return;
            item.subMenus.forEach((group: any) => {
              if (!group.subMenuItems) return;
              group.subMenuItems.forEach((sub: any) => {
                if (
                  sub.is_active == 1 &&
                  sub.website &&
                  String(sub.website).toLowerCase() === 'tnemis-react'
                ) {
                  reactFromMixed.push({
                    ...sub,
                    _parentId: item.id,
                    _parentLabel: item.label,
                  });
                }
              });
            });
          });

        menuDetails = {
          tnemis: angularItems,
          'tnemis-react': reactItems,
          'tnemis-react-children': reactFromMixed,
          other: [],
        };
      } catch (menuErr) {
        console.error('Failed to fetch menu JSON:', menuErr);
      }

      const angularMenus = menuDetails.tnemis || [];
      const reactMenus = menuDetails['tnemis-react'] || [];
      const menuList: any[] = [...angularMenus, ...reactMenus];

      // ── Step 2b: Fetch currentAy (fire-and-forget style) ──
      try {
        const ayRes = await getCurrentAy().unwrap();
        if (ayRes?.dataStatus && ayRes?.result?.[0]) {
          localStorage.setItem('currentAy', JSON.stringify(ayRes.result[0]));
        }
      } catch {
        /* currentAy fetch failed — non-blocking */
      }

      // ── Step 3: Add static menus (SMC Dashboard, SLAS) — same as Angular ──
      const emisUserType = Number(sessionData?.usertypeid) || 0;
      const emisUserType1 = Number(sessionData?.emisUsertype1) || 0;
      const schoolKeyId = Number(sessionData?.schoolKeyId) || 0;

      const encryptedUrNme = CryptoJS.AES.encrypt(
        username,
        'SecretKeyEmis@2025'
      ).toString();
      const encryptedToken = CryptoJS.AES.encrypt(
        localStorage.getItem('token') || '',
        'SecretKeyEmis@2025'
      ).toString();
      const encryptedAuth = CryptoJS.AES.encrypt(
        localStorage.getItem('AuthorizationKey') || '',
        'SecretKeyEmis@2025'
      ).toString();
      console.log('ENV_CONFIG.smcSiteURL', ENV_CONFIG.smcSiteURL);
      // SMC Dashboard menu
      const smcItem = {
        id: 9999998,
        isTitle: false,
        label: 'SMC',
        link: ENV_CONFIG.smcSiteURL + 2 + encryptedUrNme,
        report_category: null,
        report_format: null,
        report_link: null,
        report_sta_dyn: null,
        report_type: null,
        sequence_id: null,
      };
      const smcTitleItem = {
        id: 9999996,
        isTitle: true,
        label: 'SMC',
        link: '',
        icon: '',
        report_category: null,
        report_format: null,
        report_link: null,
        report_sta_dyn: null,
        report_type: null,
        sequence_id: null,
      };

      const showSmcDashboard =
        (emisUserType === 51 && emisUserType1 === 3) ||
        (emisUserType === 69 && emisUserType1 === 5) ||
        (emisUserType === 21 && emisUserType1 === 3) ||
        (emisUserType === 15 && emisUserType1 === 9) ||
        (emisUserType === 5 && emisUserType1 === 27) ||
        (emisUserType === 5 && emisUserType1 === 33) ||
        (emisUserType === 15 && emisUserType1 === 11) ||
        (emisUserType === 5 && emisUserType1 === 8) ||
        (emisUserType === 5 && emisUserType1 === 35);

      const showMsCms =
        (emisUserType === 51 && emisUserType1 === 3) ||
        (emisUserType === 21 && emisUserType1 === 3);

      if (showSmcDashboard || showMsCms) {
        const cmsItem = {
          id: 9999997,
          isTitle: false,
          label: 'MS-CMS',
          link:
            ENV_CONFIG.cmsMS +
            '?' +
            'Auth=' +
            encodeURIComponent(encryptedAuth) +
            '&token=' +
            encodeURIComponent(encryptedToken),
          report_category: null,
          report_format: null,
          report_link: null,
          report_sta_dyn: null,
          report_type: null,
          sequence_id: null,
        };

        const subMenuItems: any[] = [smcTitleItem];
        if (showSmcDashboard) {
          subMenuItems.push(smcItem);
        }
        if (showMsCms) {
          subMenuItems.push(cmsItem);
        }

        const smcMenu = {
          icon: 'check-square',
          id: 9999999,
          isMegaMenu: true,
          label: 'SMC Dashboard',
          link: '',
          sequence_id: 9999999,
          subMenus: [{ subMenuItems }],
        };
        menuList.push(smcMenu);
      }
      console.log('ENV_CONFIG.slasSiteURL', ENV_CONFIG.slasSiteURL);
      // SLAS Assessment menu
      const slasMenu = {
        icon: '',
        id: 999999,
        isMegaMenu: false,
        label: 'SLAS Assessment',
        link: '',
        sequence_id: 9999999,
        subMenus: [
          {
            subMenuItems: [
              {
                id: 9999999,
                isTitle: false,
                label: 'SLAS 2024 - 25',
                link: ENV_CONFIG.slasSiteURL + 2 + encryptedUrNme,
                report_category: null,
                report_format: null,
                report_link: null,
                report_sta_dyn: null,
                report_type: null,
                sequence_id: null,
              },
            ],
          },
        ],
      };

      const showSlas =
        [9, 19, 36, 22, 30, 3, 5, 13, 37, 52, 38, 6, 21].includes(
          emisUserType
        ) ||
        (emisUserType === 39 && emisUserType1 === 2) ||
        (emisUserType === 24 && emisUserType1 === 6) ||
        (emisUserType === 40 && emisUserType1 === 4);

      if (showSlas) {
        menuList.push(slasMenu);
      }

      // ── Step 4: Build modList ──
      let modList = rawModList;
      // Add static menu IDs to modList
      modList = modList + ',999999,9999999,9999998,9999997,9999996';

      // Special user type filter
      if (
        emisUserType === 6 &&
        emisUserType1 === 1 &&
        username !== '20077470'
      ) {
        modList = modList.replaceAll(',994', '');
      }

      // Merge react IDs into modList
      const collectAllIds = (nodes: any[]): string[] => {
        if (!nodes) return [];
        const ids: string[] = [];
        nodes.forEach((node) => {
          if (node?.id != null) ids.push(String(node.id));
          if (node?.subMenus) {
            node.subMenus.forEach((group: any) => {
              ids.push(...collectAllIds(group?.subMenuItems || []));
            });
          }
        });
        return ids;
      };

      const reactIds = collectAllIds(reactMenus);
      if (reactIds.length > 0) {
        modList = modList + ',' + reactIds.join(',');
      }

      // ── Step 5: Save to localStorage ──
      localStorage.setItem('MenuList', JSON.stringify(menuList));
      localStorage.setItem('ModList', JSON.stringify(modList));
      localStorage.setItem('ReactMenus', JSON.stringify(reactMenus));
      localStorage.setItem(
        'ReactMenuChildren',
        JSON.stringify(menuDetails['tnemis-react-children'] || [])
      );

      hideLoader();
      alertService.success('Login Successful');

      localStorage.setItem('token', token);
      localStorage.setItem('username', username);

      // Fire-and-forget: prime Angular TNEMIS session via iframe bridge
      primeAngularSession();

      // Route HR users (usertype=21, usertype1=23) to mail-request portal
      if (
        (emisUserType === 21 && emisUserType1 === 23) ||
        username === '4028619'
      ) {
        navigate('/mail-request');
      } else {
        navigate('/dashboard');
      }
    } catch (error: any) {
      hideLoader();
      const message =
        error?.data?.message ||
        error?.data?.error ||
        error?.message ||
        'Login Failed';
      toast.dismiss();
      alertService.error(message);
    }
  };
  // const getAuthorizationKey = async () => {
  //   try {
  //     const response = await fetch(
  //       'https://fcabjcr87c.execute-api.ap-south-1.amazonaws.com/api/authkey'
  //     );

  //     const result = await response.json();

  //     const parsedJson = JSON.parse(result.body);

  //     localStorage.setItem('AuthorizationKey', parsedJson.Authorization_key);

  //     return true;
  //   } catch (error) {
  //     console.error(error);
  //     return false;
  //   }
  // };
  // ================= SHOW FORGOT PASSWORD =================
  const handleForgotPassword = () => {
    setShowLoginPage(false);
    setShowForgotPasswordPage(true);
  };

  // ================= BACK TO LOGIN =================
  const handleBackToLogin = () => {
    setShowForgotPasswordPage(false);
    setShowLoginPage(true);

    setForgotUsername('');
    setOtpValue('');
    setNewPassValue('');
    setShowPass(false);
  };

  const requestOtp = async () => {
    setForgetSubmitted(true);

    if (!forgotUsername.trim()) {
      alertService.warning('Please enter the User Id');
      return;
    }

    try {
      showLoader();

      const payload = {
        UserId: forgotUsername,
        newPassword: confirmPassword,
      };

      const apiResponse = await requestOtpApi(payload).unwrap();

      const decryptedResponse: any = decryptData(apiResponse);

      hideLoader();

      if (decryptedResponse?.dataStatus) {
        setShowPass(false);
        setOtpValue('');
        setNewPassValue('');
        setValidation(true);

        setOtpConfirmation(true);

        alertService.success(
          decryptedResponse?.message || 'OTP Sent Successfully'
        );
      } else {
        alertService.error(decryptedResponse?.message || 'Failed to send OTP'); // ← THIS LINE
      }
    } catch (error: any) {
      hideLoader();

      alertService.error(error?.data?.message || 'Something went wrong');
    }
  };
  // ================= OPEN OTP POPUP =================
  const showOtpSubmit = () => {
    setForgetSubmitted(true);

    if (!forgotUsername.trim()) {
      alertService.error('Please Enter User ID');
      return;
    }

    setShowPass(false);
    setOtpValue('');
    setNewPassValue('');
    setValidation(true);

    setOtpConfirmation(true);
  };

  // ================= SUBMIT OTP =================
  const submitOtp = async () => {
    if (!otpValue) {
      alertService.error('Please Enter the OTP');
      return;
    }

    try {
      showLoader();

      const response = await submitOtpApi({
        username: forgotUsername,
        otp: otpValue,
      }).unwrap();

      const decryptedResponse: any = decryptData(response);

      hideLoader();

      if (decryptedResponse?.dataStatus) {
        alertService.success(decryptedResponse?.message);

        // OPEN PASSWORD FIELD ONLY AFTER SUCCESS
        setShowPass(true);
      } else {
        alertService.error(decryptedResponse?.message);
      }
    } catch (error: any) {
      hideLoader();

      alertService.error(error?.data?.message || 'Something went wrong');
    }
  };

  // ================= PASSWORD VALIDATION =================
  const checkPasswordValid = (value: string) => {
    setNewPassValue(value);

    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,15}$/;

    setValidation(regex.test(value));
  };

  const closeOtpPopup = () => {
    setOtpConfirmation(false);
    setShowPass(false);
    setOtpValue('');
    setNewPassValue('');
    setValidation(true);
  };

  // ================= SUBMIT PASSWORD =================
  const submitPassword = async () => {
    if (!validation || !newPassValue) {
      alertService.error('Please enter the valid password');
      return;
    }

    try {
      showLoader();

      const response = await updatePasswordApi({
        username: forgotUsername,
        newPass: newPassValue,
      }).unwrap();

      const decryptedResponse: any = decryptData(response);

      hideLoader();

      if (decryptedResponse?.dataStatus) {
        alertService.success(
          decryptedResponse?.message || 'Password Changed Successfully'
        );

        setOtpConfirmation(false);

        handleBackToLogin();
      } else {
        alertService.error(decryptedResponse?.message);
      }
    } catch (error: any) {
      hideLoader();

      alertService.error(error?.data?.message || 'Something went wrong');
    }
  };

  return (
    <div className="row w-100 mx-0 auth-page">
      <div className="col-md-8 col-xl-6 mx-auto">
        <div className="card">
          <div className="row g-0">
            <div className="col-md-4 pe-md-0 imagelogo">
              <div
                className="auth-side-wrapper"
                style={{
                  backgroundImage: `url(${illustration})`,
                }}
              />
            </div>

            <div className="col-md-8 ps-md-0">
              <div
                className={`auth-form-wrapper px-4 py-5${showForgotPasswordPage ? ' forgot-mode' : ''}`}
                style={{
                  fontFamily: 'Arial, sans-serif',
                  fontSize: '14px',
                  lineHeight: '1.5',
                }}
              >
                <img src={logo} className="image" alt="Government Logo" />

                <h5 className="headingcenter1 text-muted fw-normal mb-4 text-center">
                  கல்வி மேலாண்மைத் தகவல் மையம்
                </h5>

                {/* ================= LOGIN PAGE ================= */}

                {showLoginPage && (
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleLogin();
                    }}
                  >
                    <div className="mb-3">
                      <label htmlFor="loginUsername" className="form-label">
                        User Name
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        id="loginUsername"
                        placeholder="User Name"
                        value={username}
                        maxLength={8}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(
                            /[^0-9]/g,
                            ''
                          );
                          setUsername(numericValue);
                        }}
                        onBlur={() => setUsernameTouched(true)}
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />

                      {usernameError && (
                        <small className="form-text text-danger">
                          Enter User Name
                        </small>
                      )}
                    </div>

                    <div className="mb-3">
                      <label htmlFor="loginPassword" className="form-label">
                        Password
                      </label>

                      <div className="position-relative w-100">
                        <input
                          type={passShow ? 'password' : 'text'}
                          className="form-control pe-5"
                          id="loginPassword"
                          placeholder="Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          onBlur={() => setPasswordTouched(true)}
                        />

                        <i
                          className={`${passShow ? 'pi pi-eye' : 'pi pi-eye-slash'} position-absolute top-50 end-0 translate-middle-y me-3`}
                          style={{ cursor: 'pointer' }}
                          onClick={() => setPassShow(!passShow)}
                        />
                      </div>

                      {passwordError && (
                        <small className="text-danger">Enter Password</small>
                      )}
                    </div>

                    <div className="row mt-2">
                      <div className="col-12 text-center">
                        <button
                          type="submit"
                          className="btn btn-primary me-2 mb-2 mb-md-0"
                        >
                          Login
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary me-2 mb-2 mb-md-0"
                          onClick={handleForgotPassword}
                        >
                          Forgot Password
                        </button>
                      </div>
                    </div>
                  </form>
                )}

                {/* ================= FORGOT PASSWORD PAGE ================= */}

                {showForgotPasswordPage && (
                  <div className="forgot-password-form">
                    <div className="mb-2">
                      <label className="form-label">
                        Enter User Id
                        <span className="text-danger"> *</span>
                      </label>

                      <input
                        type="text"
                        className="form-control forgot-input"
                        placeholder="Enter User Id"
                        value={forgotUsername}
                        onChange={(e) => {
                          const numericValue = e.target.value.replace(
                            /[^0-9]/g,
                            ''
                          );
                          setForgotUsername(numericValue);
                        }}
                        onBlur={() => setForgotTouched(true)}
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />

                      {forgotError && (
                        <small className="form-text text-danger">
                          Enter User Id
                        </small>
                      )}
                    </div>

                    <br />

                    <div className="row">
                      <div className="col text-center">
                        <button
                          type="button"
                          className="btn btn-primary me-2 mb-2 mb-md-0"
                          onClick={requestOtp}
                        >
                          Request OTP
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary me-2 mb-2 mb-md-0"
                          onClick={showOtpSubmit}
                        >
                          Submit OTP
                        </button>

                        <button
                          type="button"
                          className="btn btn-primary me-2 mb-2 mb-md-0"
                          onClick={handleBackToLogin}
                        >
                          Back To Login
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= OTP SUCCESS POPUP ================= */}

      {/* {showSuccessOtp && (
        <div className="custom-modal">
          <div className="custom-modal-content text-center">
            <h5>OTP Sent Successfully</h5>

            <p className="mt-3">OTP sent to your registered mail/mobile</p>

            <button
              className="btn btn-warning mt-2"
              onClick={() => setShowSuccessOtp(false)}
            >
              Ok
            </button>
          </div>
        </div>
      )} */}

      {otpConfirmation && !showPass && (
        <div className="otp-modal">
          <div className="otp-modal-content">
            <div className="otp-modal-header">OTP Submission</div>

            <div className="otp-modal-body">
              <div className="otp-input-section">
                <label className="form-label">
                  OTP <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className="form-control otp-input"
                  placeholder="Enter the OTP"
                  maxLength={6}
                  value={otpValue}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/[^0-9]/g, '');
                    setOtpValue(numericValue);
                  }}
                  inputMode="numeric"
                  pattern="[0-9]*"
                />
              </div>

              <div className="otp-footer">
                <button className="btn-submit-otp" onClick={submitOtp}>
                  Submit OTP
                </button>
                <button className="btn-close-otp" onClick={closeOtpPopup}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* ================= OTP SUBMISSION POPUP ================= */}

      {otpConfirmation && showPass && (
        <div className="custom-modal">
          <div className="custom-modal-content">
            {/* Header */}
            <div className="password-popup-header">OTP Submission</div>

            {/* Body */}
            <div className="password-popup-body">
              <div className="new-password-section">
                <label className="form-label">
                  New Password <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className="form-control password-input"
                  placeholder="Enter the new password"
                  value={newPassValue}
                  maxLength={15}
                  onChange={(e) => checkPasswordValid(e.target.value)}
                />

                {!validation && (
                  <div className="password-error-box">
                    <i className="pi pi-times-circle" />
                    Enter New Password
                  </div>
                )}

                <p className="password-note">
                  <b>Note:</b> Password must contain at least one lowercase, at
                  least one uppercase, at least one numeric, minimum 8
                  characters and maximum 15 characters.
                </p>
              </div>

              <div className="popup-footer">
                <button className="btn-submit-otp" onClick={submitPassword}>
                  Submit
                </button>

                <button className="btn-close-popup" onClick={closeOtpPopup}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
